import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';
import ReactSignatureCanvas from 'react-signature-canvas';
import { DefaultButton } from '../buttons';

const SignaturePad = forwardRef(({ isHighlighted, onEnd }, ref) => (
  <div>
    <ReactSignatureCanvas
      ref={ref}
      penColor="#1f2933"
      onEnd={onEnd}
      canvasProps={{
        className: `w-full border-2 border-dashed rounded-md
          ${isHighlighted ? 'border-red-300' : 'border-gray-300'}`,
        style: { height: '160px' },
      }}
    />
    <DefaultButton
      customStyles="mt-2 text-sm"
      label="Clear signature"
      onClick={() => ref?.current?.clear()}
    />
  </div>
));

SignaturePad.propTypes = {
  isHighlighted: PropTypes.bool,
  onEnd: PropTypes.func,
};

SignaturePad.defaultProps = {
  isHighlighted: false,
  onEnd: () => {},
};

export default SignaturePad;
